import {
  FontLoader,
  LoadingManager,
  TextureLoader,
  AudioLoader,
  LinearFilter,
  sRGBEncoding,
  MeshBasicMaterial,
  MeshPhongMaterial,

} from "three";


export function loadJsons(jsons) {

  return new Promise((resolve) => {
    var ajax = new XMLHttpRequest();
    jsons.forEach( json => {
      ajax.open("GET", json.file, false );
      ajax.send();
      json.data = JSON.parse(ajax.responseText);
    });
    resolve(jsons);
  });

}

export function loadSounds( sounds ) {
  return new Promise((resolve) => {
    let audio, element;
    sounds.forEach( sound => {
      audio = new Audio();
      element = document.createElement("source");
      element.type = "audio/mpeg";
      element.src  = sound.file;
      audio.loop = sound.loop;
      audio.volume = sound.volume;
      audio.appendChild(element);
      sound.audio = audio;
    });
    resolve(sounds); // TO DO: WAIT FOR ALL TO LOAD BEFORE RESOLVE
  });
}

export function loadImages( images ){
  return new Promise((resolve) => {
    images.forEach( image => {
      image.data = new Image();
      image.data.onload = ()=>{
        
      };
      image.data.src = image.file;
    });
    resolve(images); // TO DO: WAIT FOR ALL TO LOAD BEFORE RESOLVE
  });
}

export function _loadSounds( sounds ) {
  return new Promise((resolve, reject) => {
    // let textures = [];
    let onLoad = ()=>{
      resolve(sounds);
    };
    let onProgress = ()=>{};
    let onError = () =>{
      reject(false);
    };
    let manager = new LoadingManager(onLoad, onProgress, onError);
    sounds.forEach(sound => {
      let loader = new AudioLoader(manager);
      sound.audio = loader.load(sound.file);
      console.log( sound )
    });
  });
}

export function loadTextures( textures ) {
  return new Promise((resolve, reject) => {
    // let textures = [];
    let onLoad = ()=>{
      resolve(textures);
    };
    let onProgress = ()=>{};
    let onError = () =>{
      reject(false);
    };
    let manager = new LoadingManager(onLoad, onProgress, onError);
    textures.forEach(texture => {
      let loader = new TextureLoader(manager);
      texture.map = loader.load(texture.file);
      texture.map.encoding = sRGBEncoding;
      texture.material = ( texture.basic ) ? new MeshBasicMaterial({map: texture.map}) : new MeshPhongMaterial({map: texture.map});
      texture.material.minFilter = LinearFilter;
      texture.material.generateMipmaps = false;
      texture.material.needsUpdate = false;
      // if( texture.basic ) console.log( 'basic!', texture.name );
      if( texture.transparent ) texture.material.transparent = true;
    });
  });
}

export function loadFonts( fonts ) {
  return new Promise((resolve, reject) => {

    let wait = false; // HACK: need to wait for non three js fonts too :(

    const onLoad = ()=>{
     if( !wait ) resolve(fonts);
    };
    const onProgress = ()=>{};
    const onError = () =>{
      reject(false);
    };

    const manager = new LoadingManager(onLoad, onProgress, onError);

    fonts.forEach(font => {

      if( !font.file.includes('.json') ){

        wait = true;

        //https://stackoverflow.com/questions/40199805/unable-to-use-a-google-font-on-canvas

        // THIS DID NOT WORK AND INSTEAD USED CSS IMPORT https://codepen.io/Sfear/pen/QELYYr

        const fontFace = new FontFace(
          font.name,
          "url(" + font.file + ")"
        );

        console.log('font', fontFace)

        fontFace.load().then((response) => {
          document.fonts.add(response);
          console.log('font', response)
          console.log( 'LOADED', document.fonts.check("32px '"+font.name+"'"), response );
          font.data = response;
          wait = false;
          onLoad();
        });

      }else{
        const loader = new FontLoader(manager);
        loader.load(font.file, (response)=>{
          font.data = response;
        });
      }

    });
  });
}
